import * as React from 'react';
import { Layout } from 'antd';
import { useMsal } from '@azure/msal-react';
import NavMenu from './NavMenu';
import AuthStatus from './AuthStatus';
import { CharacterMapSetupModal } from './CharacterMapSetupModal';
import { AuthClient } from '../utils/scanner-backend';
import { ApiConfig } from '../utils/AuthorizedApiBase';
import { useActiveToolTheme } from '../hooks/useActiveToolTheme';

export default (props: { children?: React.ReactNode }) => {
    const { instance } = useMsal();
    const [initialized, setInitialized] = React.useState(false);
    const [isCharacterMapModalVisible, setIsCharacterMapModalVisible] = React.useState(false);
    const toolTheme = useActiveToolTheme();

    React.useEffect(() => {
        // Initialize user's admin record in the database
        const initializeUser = async () => {
            try {
                const authClient = new AuthClient(new ApiConfig());
                const data = await authClient.initialize();
                console.log('User initialized:', data.AdminId);
            } catch (error) {
                console.error('Error initializing user:', error);
            } finally {
                setInitialized(true);
            }
        };

        if (!initialized) {
            initializeUser();
        }
    }, [instance, initialized]);

    return (
        <React.Fragment>
            {toolTheme && (
                <div className="active-tool-label" style={{ background: toolTheme.color }}>
                    {toolTheme.label}
                </div>
            )}
            {toolTheme && (
                <div className="active-tool-frame" style={{ borderColor: toolTheme.color }} />
            )}
            <Layout>
                <Layout.Header className="app-header">
                    <div className="header-content">
                        <div className="nav-menu-wrapper">
                            <NavMenu
                                onOpenCharacterMapSetup={() => setIsCharacterMapModalVisible(true)}
                            />
                        </div>
                        <AuthStatus />
                    </div>
                </Layout.Header>
                <Layout.Content className="container">
                    {props.children}
                </Layout.Content>
                <Layout.Footer></Layout.Footer>
            </Layout>

            {/* Character Map Setup Modal */}
            <CharacterMapSetupModal
                visible={isCharacterMapModalVisible}
                onClose={() => setIsCharacterMapModalVisible(false)}
            />
        </React.Fragment>
    );
};
